import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { SECONDS_TO_MILLIS } from "lopermut"
import { ImportStatusResponseDataSchema } from "schema"
import z from "zod"

type ImportStatus = z.infer<typeof ImportStatusResponseDataSchema>

const REFETCH_INTERVAL = 20 * SECONDS_TO_MILLIS

export function customerImportStatusQuery(id: string) {
  return queryOptions({
    queryKey: ["import", id],
    queryFn: async (): Promise<ImportStatus> => {
      const { data } = await axios.get<{ data: ImportStatus }>(`/importers/imports/${id}`)
      return data.data
    },
    refetchInterval: (query) => {
      const status = query.state.data?.status
      return status === "COMPLETED" || status === "FAILED" ? false : REFETCH_INTERVAL
    },
  })
}
